
import { useState } from 'react'
import './styles/reportes.css'
import Disponibilidad from '../components/reportes-components/Disponibilidad'
import Alineacion from '../components/reportes-components/Alineacion'
import Herramienta1 from '../components/admin-components/Herramienta1'
import RolesAdmin from '../components/admin-components/RolesAdmin'
import ArrastreHost from '../components/admin-components/ArrastreHost'
import { lang } from '../components/generales/traduction'
import InternalError from '../components/generales/InternalError'
import DisponibilidadHost from '../components/reportes-components/DisponibilidadHost'
import PanelEventsHistoric from '../components/reportes-components/PanelEventsHistoric'
import PanelEventsTickets from '../components/reportes-components/PanelEventsTickets'
import PanelBI from '../components/reportes-components/PanelBI'
import PanelKpi from '../components/reportes-components/PanelKpi'
import PanelGraphicKpi from '../components/reportes-components/PanelGraphicKpi'
import PanelGraphicMetric from '../components/reportes-components/PanelGraphicMetric'
import PanelHistoricDisp from '../components/reportes-components/PanelHistoricDisp'
const Reportes=({server,dataGlobals,pageSelected,languaje,mode,handleShowPopup })=>{
    const [listSelected,setListSelected]=useState(1)
    const [internalError,setInternalError]=useState(false)
    const hadleChangeList=(e)=>{
        setListSelected(e)
    }

    function renderAdminComponent() {
        try {
            switch (pageSelected) {
                case "reporte-disp":
                    return <Disponibilidad languaje={languaje} mode={mode} server={server} setInternalError={setInternalError} />;
                case "reporte-disp-host":
                    return <DisponibilidadHost languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
                case "reporte-eventos-historic":
                        return <PanelEventsHistoric handleShowPopup={handleShowPopup}  languaje={languaje} mode={mode} server={server} setInternalError={setInternalError} />;
                case "reporte-eventos-tickets":
                        return <PanelEventsTickets handleShowPopup={handleShowPopup}languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
                case "reporte-BI":
                    return <PanelBI languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
                case "reporte-graph-metrica":
                    return <PanelGraphicMetric handleShowPopup={handleShowPopup}languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
                case "reporte-graph-kpi":
                    return <PanelGraphicKpi handleShowPopup={handleShowPopup}languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
                case "reporte-kpi":
                    return <PanelKpi handleShowPopup={handleShowPopup}languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
                case "reporte-historicDisp":
                    return <PanelHistoricDisp  handleShowPopup={handleShowPopup}languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>           
                default:
                    return <Herramienta1 server={server} setInternalError={setInternalError}/>;
            }
        } catch (error) {
            console.error('Error rendering component:', error);
            return <div>{lang[languaje['msgErrorPagina']]}</div>;
        }
    }
    window.onerror = function (message, source, lineno, colno, error) {
        console.error('Error global capturado:', message, source, lineno, colno, error);
        // Manejo de errores global, por ejemplo, mostrando una notificación
      };
    return (
        <div className="main-config">
             {(internalError)?
            <InternalError/>
            :renderAdminComponent()}
            
        </div>
    )
}

export default Reportes